export enum MdrFlexModalityEnum {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  ADDITIONAL_PER_INSTALLMENT = 'ADDITIONAL_PER_INSTALLMENT',
  CREDIARIO = 'CREDIARIO',
  VOUCHER = 'VOUCHER',
}
